<template>
  <div class="box">
    <!-- 封面图 -->
    <div class="cover"></div>
    <!-- 产品名称  价格 -->
    <div class="Product-Name">
      <p>洪驰供应链管理公司logo设计</p>
      <p>￥ 5000</p>
    </div>
    <!-- 案例标签 -->
    <p class="title">案例标签：</p>
    <div class="CaseTagArr">
      <p v-for="(item, index) in CaseTagArr" :key="index">{{ item }}</p>
    </div>
    <!-- 案例背景 -->
    <p class="title">案例背景：</p>
    <p class="text">
      宏驰供应链管理公司委托我方设计logo品牌设计，当时我们形象化的将图形展示结合文字创意设计体现logo的实用性和美观度，图文结合的形式体现企业精神和目标为设计理念！
    </p>
    <!-- 案例展示描述 -->
    <p class="title">案例展示描述：</p>
    <p class="text">
      宏驰供应链管理公司委托我方设计logo品牌设计，当时我们形象化的将图形展示结合文字创意设计体现logo的实用性和美观度，图文结合的形式体现企业精神和目标为设计理念！
    </p>
    <!-- 案例展示信息 -->
    <p class="title">案例展示信息：</p>
    <p class="text">
      创意无限，品质至上！我们的宣传册设计服务，为您的品牌量身打造独特魅力。从构思到呈现，每一步都充满匠心与热情。
      让您的宣传册成为市场中的亮点，吸引更多目光。选择我们，让您的品牌故事在精美的设计中绽放光彩！
    </p>
    <!-- 下方图片 -->
    <div class="cover"></div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      CaseTagArr: ["企业名称变更", "公司地址变更", "工商年报"], //案例标签
    };
  },
  components: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped lang="less">
//
.box {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  color: #666666;
  // title
  .title {
    font-size: 14px;
    color: #666666;
    margin: 40px 0px 20px 0px;
  }
  // 封面
  .cover {
    width: 601px;
    height: 270px;
    background: #eeeeee;
    margin: 0 auto;
    margin-top: 20px;
  }
  // 产品名  价格
  .Product-Name {
    width: 601px;
    height: 25px;
    line-height: 25px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    p {
      font-size: 18px;
      color: #333333;
    }
    p:nth-child(2) {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      font-size: 20px;
      color: #fe574a;
    }
  }
  // 案例标签
  .CaseTagArr {
    width: 100%;
    min-height: 35px;
    line-height: 35px;
    display: flex;
    flex-wrap: wrap;
    p {
      min-width: 110px;
      height: 33px;
      background: rgba(97, 144, 232, 0.2);
      border: 1px solid #409eff ;
      border-radius: 5px;
      font-size: 12px;
      color: #409eff ;
      text-align: center;
      margin-right: 20px;
    }
  }
  //
  .text {
    width: 1140px;
    min-height: 20px;
    font-size: 12px;
    color: #333333;
    letter-spacing: 1px;
    line-height: 20px;
    text-indent: 28px;
  }
}
</style>
